module.exports = __webpack_public_path__ + "img/geolocalisation_famille_boutrais.c1071209.png";